// extracted by mini-css-extract-plugin
export default {"contentWrap":"Job_contentWrap__-QcyU","btnWrap":"Job_btnWrap__NQYnB"};